import { css } from '@emotion/react';

import { AGES_PER_GAME } from '@mythos/game/GameConstants';
import { GameViewModel } from '@mythos/game/GameViewModel';
import { getPhaseName } from '@mythos/game/Phases';
import { getMaxCountersForAge } from '@mythos/game/Rules';
import { ageString } from '@mythos/game/Utility';
import { PhaseToBackgroundColor, UIColorPalette } from './ColorPalette';
import GameTimeView from './GameTimeView';
import Symbols, { PhaseToSymbol, SymbolView } from './Symbols';

export default function GameStateView(props: { game: GameViewModel }) {
  const { game } = props;

  const backgroundColor = PhaseToBackgroundColor[game.phase];
  const { maxGold, maxMilitary } = getMaxCountersForAge(
    game.age,
    game.options.tokenCap,
  );

  return (
    <div
      css={GameStateStyles.container}
      style={{
        backgroundColor,
      }}
    >
      <span css={GameStateStyles.sub_container}>
        <span css={GameStateStyles.span}>
          <SymbolView
            symbol={PhaseToSymbol[game.phase]}
            css={GameStateStyles.symbol}
          />
        </span>
        <span css={GameStateStyles.span}>{getPhaseName(game.phase)}</span>
      </span>
      <span css={GameStateStyles.sub_container}>
        <span css={GameStateStyles.span}>
          Turn {game.turn}/{game.turnsPerAge}
        </span>
        <span css={GameStateStyles.span}>
          Age {ageString(game.age)}/{ageString(AGES_PER_GAME)}
        </span>
        <span css={[GameStateStyles.span, GameStateStyles.capContainer]}>
          Cap:
          <SymbolView symbol={Symbols.GOLD} css={GameStateStyles.capSymbol} />
          {maxGold}
          <SymbolView
            symbol={Symbols.MILITARY}
            css={GameStateStyles.capSymbol}
          />
          {maxMilitary}
        </span>
        <span css={GameStateStyles.span}>
          <GameTimeView
            splitStartTimestamp={
              game.gameEndTimestamp ? undefined : game.gameStartTimestamp!
            }
            extraSplitTime={
              game.gameEndTimestamp
                ? game.gameEndTimestamp - game.gameStartTimestamp!
                : undefined
            }
          />
        </span>
      </span>
    </div>
  );
}

const GameStateStyles = {
  container: css({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',

    margin: 5,
    padding: 5,

    color: UIColorPalette.gameStateText,

    transition: 'background-color 0.5s',
  }),
  sub_container: css({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  }),
  span: css({
    marginLeft: 10,
    marginRight: 10,
  }),
  symbol: css({
    width: 25,
    height: 25,
    margin: 0,
  }),
  capContainer: css({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  }),
  capSymbol: css({
    height: 16,
    width: 16,
    marginLeft: 4,
    marginRight: 2,
  }),
} as const;
